// extracted by mini-css-extract-plugin
export var container = "_88-1";
export var cornerButtonContainer = "_88-5";
export var disabled = "_88-2";
export var fileContainer = "_88-4";
export var hiddenInput = "_88-3";
export var widthContainer = "_88-0";